module.exports = __webpack_public_path__ + "img/esa.e85d05a4.png";